/**
 * Sort Utils
 *
 * @since 2018-03-29
 * @author kdydesign.kim
 */

import BigNumber from 'bignumber.js'
import {isOrderedIp} from './ip'

// sort
export function sortData () {
  return 'sort'
}

// 문자, 숫자가 혼용된 문자열을 소트하기 위한 코드 - START
// https://tonks.tistory.com/117

/* 숫자인 실수만으로 되어있을 때, 적용될 함수 */
function sortingNumber (a, b) {
  if (typeof a === 'number' && typeof b === 'number') {
    return a - b
  }

  // 천단위 쉼표와 공백문자만 삭제하기.
  a = (a + '').replace(/[,\s\xA0]+/g, '')
  b = (b + '').replace(/[,\s\xA0]+/g, '')

  const numA = parseFloat(a) + ''
  const numB = parseFloat(b) + ''

  if (numA === 'NaN' || numB === 'NaN' || a !== numA || b !== numB) {
    return false
  }
  return parseFloat(a) - parseFloat(b)
}

/* changeForSorting() : 문자열 바꾸기. */
function changeForSorting (first, second) {
  // 문자열의 복사본 만들기.
  let a = first.toString().replace(/[\s\xA0]+/g, ' ')
  let b = second.toString().replace(/[\s\xA0]+/g, ' ')

  const change = {first: a, second: b}
  if (a.search(/\d/) < 0 || b.search(/\d/) < 0 || a.length === 0 || b.length === 0) return change

  const regExp = /(\d),(\d)/g // 천단위 쉼표를 찾기 위한 정규식.

  a = a.replace(regExp, '$1' + '$2')
  b = b.replace(regExp, '$1' + '$2')

  let unit = 0
  const aNb = a + ' ' + b
  const numbers = aNb.match(/\d+/g) // 문자열에 들어있는 숫자 찾기

  for (let x = 0; x < numbers.length; x++) {
    const length = numbers[x].length
    if (unit < length) unit = length
  }

  const addZero = function (string) { // 숫자들의 단위 맞추기
    const match = string.match(/^0+/)
    if (string.length === unit) return (match == null) ? string : match + string
    const zero = '0'
    for (let x = string.length; x < unit; x++) string = zero + string
    return (match === null) ? string : match + string
  }
  change.first = a.replace(/\d+/g, addZero)
  change.second = b.replace(/\d+/g, addZero)

  return change
}

function compare (a, b) {
  const sorting = sortingNumber(a, b)

  if (typeof sorting === 'number') {
    return sorting
  }
  const change = changeForSorting(a, b)
  a = change.first
  b = change.second

  return (a < b) ? -1 : (a === b) ? 0 : 1
}

export function sortCharNum (a, b) {
  return compare(a, b)
}

// 문자, 숫자가 혼용된 문자열을 소트하기 위한 코드 - END

// BigInt Compare 처리부
export function sortBigInt (a, b) {
  a = (a === undefined || _.isNull(a)) ? 0 : a
  b = (b === undefined || _.isNull(b)) ? 0 : b
  if (typeof a === 'number' || typeof a === 'string') {
    a = new BigNumber(a)
  }

  if (a.compareTo) {
    return a.compareTo(b)
  } else {
    return a.comparedTo(b)
  }
}

/**
 * ip 형태 sorting
 * 데이터 테이블에서 사용
 *
 * @param value1
 * @param value2
 * @returns {number}
 */
export function ipSorter (value1, value2) {
  return isOrderedIp(value1, value2) ? -1 : 1
}

/**
 * string 형태 sorting
 * 데이터 테이블에서 사용
 *
 * @param value1
 * @param value2
 * @returns {number}
 */
export function stringSorter (value1, value2) {
  if (value1 === void 0 && value2 === void 0) {
    return 0
  }

  if (value1 < value2) {
    return -1
  }

  if (value1 > value2) {
    return 1
  }

  return 0
}
